import gsap from 'gsap'
import Swiper from 'swiper'
import { Navigation, Autoplay, Parallax, Scrollbar, Pagination } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/autoplay'

let config

export const initSwiper = () => {
	const sliders = document.querySelectorAll('[data-swiper]')

	if (!sliders.length) return

	sliders.forEach((slider) => {
		const type = slider.getAttribute('data-swiper')
		const scrollbar = slider.querySelector('.swiper-scrollbar')
		const pagination = slider.querySelector('.swiper-pagination')
		const nextButton = slider.querySelector('.swiper-button-next')
		const prevButton = slider.querySelector('.swiper-button-prev')

		switch (type) {
			case 'testimonials':
				config = {
					speed: 600,
					spaceBetween: 18,
					slidesPerView: 1.05,
					centeredSlides: true,
					modules: [Scrollbar, Navigation],
					scrollbar: {
						el: scrollbar
					},
					navigation: {
						prevEl: slider.querySelector('[data-button="previous"]'),
						nextEl: slider.querySelector('[data-button="next"]'),
					},
					breakpoints: {
						1025: {
							centeredSlides: false,
							slidesPerView: 1.6,
							spaceBetween: 24
						},
						651: {
							slidesPerView: 1.5,
							spaceBetween: 24
						}
					}
				}
				break
			case 'contact-cards':
				config = {
					speed: 600,
					spaceBetween: 18,
					slidesPerView: 1.1,
					modules: [Pagination],
					pagination: {
						el: pagination,
						clickable: true,
					},
					breakpoints: {
						1025: {
							slidesPerView: 3,
						},
						651: {
							spaceBetween: 48,
							slidesPerView: 2.25,
						}
					}
				}
			break
			case 'team':
				config = { 
					speed: 600,
					spaceBetween: 18,
					slidesPerView: 1.25,
					modules: [Scrollbar],
					scrollbar: {
						el: scrollbar,
					},
					breakpoints: {
						1025: {
							slidesPerView: 4.25,
						},
						651: {
							spaceBetween: 48,
							slidesPerView: 2.5,
						}
					}
				} 
				break
			default:
			break
		}

		const swiper = new Swiper(slider, { ...config })


		if (type == 'testimonials') {
			document.querySelectorAll('.swiper-slide').forEach((slide, index) => {
				slide.addEventListener('click', () => {
					swiper.slideTo(index)
				})
			})
		}

	})
}

export default () => { }